const ClientHyfye = () => {
    return (
  <section className="client_logo small_pb">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="title_dark title_border text-center">
            <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Our Collaborators</h4>
            <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
              At Hyfye, we believe in building strong partnerships to create a global tipping economy.  
              We are proudly collaborating with trusted platforms like <strong>PinkSale</strong> and <strong>MetaMask</strong> to bring this vision to life.  
              <br /><br />
              We are actively seeking partnerships with projects, communities, brands, and visionaries who share our passion for decentralization, gratitude, and empowerment.
            </p>
          </div>
        </div>
      </div>
  
      <div className="row align-items-center justify-content-center mt-4">
        <div className="col-md-4 col-sm-6 text-center mb-4 animation" data-animation="fadeInUp" data-animation-delay="0.5s">
          <img src="assets/images/sponsors/pinksale.png" alt="PinkSale" style={{width: "150px"}} />
          <h6 className="mt-3">PinkSale</h6>
        </div>
        <div className="col-md-4 col-sm-6 text-center mb-4 animation" data-animation="fadeInUp" data-animation-delay="0.7s">
          <img src="assets/images/sponsors/meta.png" alt="MetaMask" style={{width: "150px"}} />
          <h6 className="mt-3">MetaMask</h6>
        </div>
      </div>
  
      <div className="row justify-content-center mt-5">
        <div className="col-md-8 text-center">
          <p className="animation" data-animation="fadeInUp" data-animation-delay="0.8s">
            Interested in partnering with Hyfye?  
            <br />  
            <a href="#contact" className="btn btn-default mt-3">Let's Connect</a>
          </p>
        </div>
      </div>
    </div>
  </section>
    )
  }
  
  export default ClientHyfye;
  